import React from "react";
import { Table, Image } from "semantic-ui-react";
import { get } from "lodash";
import LandlineIcon from "../../assets/images/landline.png";
import CellIcon from "../../assets/images/cell.png";
import yesImage from "../../assets/images/yes.jpg";

export const getPhoneImage = (phoneType) =>
  phoneType === "WIRELESS" ? (
    <img
      key={`img_phone_cell`}
      src={CellIcon}
      width="32px"
      height="32px"
      alt="PhoneIcon"
    />
  ) : (
    <img
      key={`img_phone_cell`}
      src={LandlineIcon}
      width="32px"
      height="32px"
      alt="PhoneIcon"
    />
  );

export const getAddressPhoneType = (node) => {
  if (get(node, "addressType[0]._") === "S")
    return <Image src={yesImage} className={"icon-size-small"} inline />;
  if (get(node, "source[0]._") === "tu") return "Historical";
  return "Secondary Source";
};

const getPhoneHeader = (props) => (
  <Table.Row key={`row_phone_header_${props.index}`}>
    <Table.Cell colSpan={2}>
      {getPhoneImage(get(props.node, "lineType[0]._"))}
      {` ${get(props.node, "phoneNumber[0]._", "")} `}
      {getAddressPhoneType(get(props.node, "source[0]._"))}
    </Table.Cell>
  </Table.Row>
);

export default getPhoneHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/PhoneHeader.js